import { BeWizrModel } from './BeWizrModel'

export class BeWizrUser extends BeWizrModel {

  public email!: string
  public fullName!: string

}